import { Box, Link, Text, VStack } from "@chakra-ui/react";
import { useNetwork } from "wagmi";

import analyticsInstance from "../config/analytics";
import { getDcaPoolContracts, getExplorerAddressLink, getSuperfluidConsoleLink } from "../config/resolver";

export default function Transparency() {
  const { chain } = useNetwork();

  return (
    <Box as="section" py="5em" px="1em" bg="#FFD1DC">
      <VStack>
        <Text fontSize="4xl" pb="0.5em">
          🕵️ Don't Trust, Verify
        </Text>

        <Text pb="0.5em">
          Want to know what's happening on-chain? Check the block explorer or the Superfluid console for the BTFDCA
          token/asset pools.
        </Text>
        {chain &&
          Object.entries(getDcaPoolContracts(chain.id)).map(([asset, tokens]) => {
            let tokensAsset = [];
            for (let t of Object.entries(tokens)) {
              tokensAsset.push(
                <Box key={t[0] + "-" + asset} py="0.25em">
                  <Text display={{ base: "block", md: "inline" }}>
                    {t[0]} / {asset}:&nbsp;
                  </Text>
                  <Link
                    href={getExplorerAddressLink(chain, t[1].contractAddress)}
                    onClick={() => analyticsInstance.track("poolBlockExplorer")}
                    isExternal
                  >
                    {t[1].contractAddress}
                  </Link>
                  &nbsp;
                  <Link
                    href={getSuperfluidConsoleLink(chain.id, t[1].contractAddress)}
                    fontSize="xs"
                    onClick={() => analyticsInstance.track("poolSuperfluidConsole")}
                    isExternal
                  >
                    [superfluid console]
                  </Link>
                </Box>
              );
            }

            return tokensAsset;
          })}
      </VStack>
    </Box>
  );
}
